import { gql } from '@apollo/client';

export const UPDATE_SITE = gql`
  mutation updateSiteMetaData($data: UpdateSiteMetaDataInput!) {
    updateSiteMetaData(data: $data) {
      id
    }
  }
`;
